<template>
  <v-container fluid>
    <v-card class="elevation-10">
      <v-skeleton-loader
        :loading="loading"
        type="table"
      >
        <v-card-actions>
          <v-row>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-toolbar
                flat
              >
                <v-toolbar-title class="md-4 white--text">
                  Fund Bucket Types
                </v-toolbar-title>
              </v-toolbar>
            </v-col>
            <v-col
              cols="4"
              md="3"
              xl="4"
            >
              <v-text-field
                v-model="search"
                placeholder="Search"
                append-icon="fa fa-search"
                label="Search Fund Bucket Item Type"
                hide-no-data
                hide-selected
                clearable
              />
            </v-col>
            <v-col
              cols="2"
              md="3"
              xl="2"
            />
            <v-col
              cols="2"
              md="3"
              xl="2"
              class="mt-2 text-right"
            >
              <bucket-fund-bucket-type-dialog-create
                @created="loadData"
              />
            </v-col>
          </v-row>
        </v-card-actions>

        <v-data-table
          dense
          :headers="headers"
          :items="fundBucketTypes"
          :items-per-page="17"
          multi-sort
          class="scrollable-table elevation-10"
          :search="search"
          data-simplebar
        >
          <template v-slot:[`item.company`]="{ item }">
            <div>
              <span>
                {{ item.name }}
              </span>
            </div>
          </template>

          <!-- <template v-slot:item.action="{ item }"> //temporary disabled
                        <FundBucketTypeEditDialog category="Fund Bucket Type" :item="item" @update="editFundBucketType"></FundBucketTypeEditDialog>
                            <span class="mx-1" />
                        <GlobalDeleteDialog category="Fund Bucket Type" :item="item" @delete="deleteFundBucketType"></GlobalDeleteDialog>
                    </template> --> 
        </v-data-table>
      </v-skeleton-loader>
    </v-card>
  </v-container>
</template>

<script>
  export default {

    data () {
      return {
        loading: true,
        search: '',
        dialog: false,
        snack: '',
        snackColor: '',
        snackText: '',
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Identifier', value: 'identifier' },
          { text: 'Transaction Mode', value: 'lookup.value' },
          { text: '', value: 'action', align: 'center', class: 'md-2', sortable: false },
        ],
        fundBucketTypes: [],
  
        editedItem: {
          name: '',
          identifier: '',
        },
        defaultItem: {
          name: '',
          identifier: '',
        },
      }
    },

    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        this.$api.fundBucketTypes().list()
          .then(response => {
            this.fundBucketTypes = response.data
            this.loading = false
          })
          .catch(err => {
            console.log(err)
          })
      },
    },
  }
</script>

<style scoped>
    .center-snackbar .v-snack__wrapper .v-snack__content{
        margin:auto !important;
        width:unset !important;
    }
</style>
